module.exports = __webpack_public_path__ + "static/media/Kassadin.0b561b21.png";